import React, { useState } from "react";
import data from "../db/data";
import ProductCard from "../components/ProductCard";
import { Search } from "lucide-react";

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredData = data.filter((item) => {
    const matchesCategory =
      selectedCategory === "All" || item.category === selectedCategory;
    const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="bg-slate-100">
      <div className="md:px-16">
        <h1 className="font-semibold text-4xl mb-3">Our Collection</h1>
        <p className="text-gray-700 mb-2">
          Discover our carefully curated selection of furniture pieces designed
          to elevate your living space.
        </p>

        {/* Search Bar */}
        <div className="relative w-[400px] h-[40px]">
          <Search className="absolute top-[50%] translate-y-[-50%] left-2 text-gray-500" />
          <input
            type="text"
            className="border-2 w-[90%] h-[100%] pl-10 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-violet-500 outline-none"
            placeholder="Search Products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="max-md:px-5 mt-3">
          {["All", "Sofas", "Chairs", "Tables", "Beds"].map((category) => (
            <button
              key={category}
              className={`p-2 rounded-xl mr-4 ${
                selectedCategory === category
                  ? "bg-green-300 text-black font-semibold"
                  : "bg-white/80 hover:bg-green-100"
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap gap-9 mt-5 mx-auto justify-center max-md:justify-center">
        {filteredData.length > 0 ? (
          filteredData.map((card) => <ProductCard card={card} key={card.id} />)
        ) : (
          <p className="text-gray-700 text-lg">No products found.</p>
        )}
      </div>
    </div>
  );
};

export default Products;
